import { Collection } from '../../reducers/types/reducerTypes'

export const checkShowsAndVideoAssetContentExistence = (
  collections: Collection<unknown>[]
) => {
  const videoAssets = collections.filter(
    (collection) => collection.slug === 'videoasset-results'
  )
  const showsAssets = collections.filter(
    (collection) => collection.slug === 'show-results'
  )

  return videoAssets.length > 0 || showsAssets.length > 0
}

export const concatNextContent = (
  responseCollection,
  filterSlug,
  currentCollections
) => {
  const collectionStateCopy = [...currentCollections]
  const filteredCollection = filterCollections(collectionStateCopy, filterSlug)

  if (filteredCollection) {
    const filteredResponseCollection = filterCollections(
      responseCollection,
      filterSlug
    )

    const concatenatedCollection = filteredCollection.content.concat(
      filteredResponseCollection.content
    )
    filteredCollection.content = uniqueByMap(concatenatedCollection)

    return filteredCollection
  }
}

export const filterCollections = (collections, filterSlug) => {
  return collections.find((collection) => collection.slug === filterSlug)
}

export const uniqueByMap = (array) => {
  const seen = new Map()
  return array.filter((item) => {
    if (seen.has(item.cid)) return false
    seen.set(item.cid, true)
    return true
  })
}
